<div #subitemContainer class="subitem-container">
  @for (subItem of routeLinkedSubItems(); track $index) {
    <div class="subitem" (mouseenter)="keepOpen(subItem.parent)" (mouseleave)="setToClose()">
      <a class="nav-item__list__link" title="{{ subItem.displayName }}" (click)="navigate(subItem.route)">
        {{ subItem.displayName }}
      </a>
    </div>
  }
</div>
